<template>
  <m-layout-mask>
    <m-layout :style="{ width: (compactSidebar ? 40 : 120) + 'px' }" v-if="isUserLoggedIn && !isActive('view', 'casino') && !isActive('page', 'bonuses')">
      <m-scrollbar>
        <m-widget-head class="sidebar-widget-head">
          <template slot="right">
            <m-hide-toggler :compact="compactSidebar" @toggle="compactSidebar = arguments[0]" />
          </template>
        </m-widget-head>
        <account-menu />
      </m-scrollbar>
    </m-layout>
    <m-layout grow>
      <router-view />
    </m-layout>
  </m-layout-mask>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MHideToggler from '@/components/buttons/MHideToggler'
import AccountMenu from '@/components/account/Menu'
import { mapState } from 'vuex'

export default {
  components: { MLayoutMask, MLayout, MScrollbar, MWidgetHead, MHideToggler, AccountMenu },
  computed: {
    ...mapState({
      isUserLoggedIn: state => state.isUserLoggedIn
    })
  },
  data () {
    return {
      compactSidebar: false
    }
  }
}
</script>

<style scoped>
.sidebar-widget-head { margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/account/Account.vue